(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["harp-homepage"] && !Shopify.designMode) return;
  try {
    
  const showHarpSignupSuccess = () => {
    const successMessage = document.querySelector('[data-harp-discount-success]');
    const signupComplete = document.querySelector('[data-harp-signup-complete]');
    const parameters = new URLSearchParams(window.location.search);
    const signupDiscountWindowName = 'harp-signup-discount-applied';
    const signupDiscountWasApplied = parameters.get('harp_signup') === 'success' || window.name === signupDiscountWindowName;

    if (signupDiscountWasApplied) {
      successMessage?.removeAttribute('hidden');
      parameters.delete('harp_signup');
      const remainingParameters = parameters.toString();
      const cleanUrl = `${window.location.pathname}${remainingParameters ? `?${remainingParameters}` : ''}${window.location.hash}`;
      window.history.replaceState({}, '', cleanUrl);

      if (window.name === signupDiscountWindowName) {
        window.name = '';
      }
    }

    if (signupComplete?.dataset.discountUrl) {
      window.name = signupDiscountWindowName;
      window.location.replace(signupComplete.dataset.discountUrl);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showHarpSignupSuccess, { once: true });
  } else {
    showHarpSignupSuccess();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["harp-wholesale"] && !Shopify.designMode) return;
  try {
    
  function initializeWholesalePreview(scope) {
    scope.querySelectorAll('[data-wholesale-preview]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      root.querySelector('[data-faire-preview]')?.addEventListener('click', () => { root.querySelector('[data-faire-feedback]').hidden = false; });
      root.querySelector('[data-preview-action]')?.addEventListener('click', () => { root.querySelector('[data-action-feedback]').hidden = false; });
      const inputs = Array.from(root.querySelectorAll('[data-unit-price]'));
      const orderType = root.querySelector('[data-order-type]');
      if (orderType) {
        const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        const update = () => {
          let total = 0;
          inputs.forEach(input => {
            const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
            total += quantity * Number(input.dataset.unitPrice);
          });
          const remaining = Math.max(0, Number(orderType.value) - total);
          root.querySelector('[data-order-total]').textContent = money.format(total / 100);
          const status = root.querySelector('[data-minimum-status]');
          status.textContent = remaining ? status.dataset.short.replace('[amount]', money.format(remaining / 100)) : status.dataset.met;
        };
        inputs.forEach(input => input.addEventListener('input', update));
        orderType.addEventListener('change', update);
        update();
      }
    });
  }
  initializeWholesalePreview(document);
  document.addEventListener('shopify:section:load', event => initializeWholesalePreview(event.target));

  } catch(e) { console.error(e); }
})();
})();
